var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderStar = function SvgIconFolderStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5v10h6.556a1 1 0 1 1 0 2H3.694A1.694 1.694 0 0 1 2 18.806V4.875a1.75 1.75 0 0 1 1.75-1.75h4.912a1.75 1.75 0 0 1 1.311.59h.001L12.45 6.5h7.801A1.75 1.75 0 0 1 22 8.25v2.25a1 1 0 1 1-2 0v-2zm4.476-3.46v.002zm.075.085L9.773 6.5H4V5.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 11a1 1 0 0 1 .919.605l1.008 2.342 2.65.206a1 1 0 0 1 .56 1.768l-1.99 1.643.608 2.445a1 1 0 0 1-1.478 1.103l-2.277-1.342-2.277 1.342a1 1 0 0 1-1.478-1.103l.608-2.445-1.99-1.643a1 1 0 0 1 .56-1.768l2.65-.206 1.008-2.342a1 1 0 0 1 .919-.605m0 3.53-.328.762a1 1 0 0 1-.841.602l-.786.061.567.468a1 1 0 0 1 .334 1.012l-.185.744.731-.431a1 1 0 0 1 1.016 0l.731.431-.184-.744a1 1 0 0 1 .333-1.012l.567-.468-.786-.061a1 1 0 0 1-.84-.602z"
  }))));
};
export default SvgIconFolderStar;